module.exports = __webpack_public_path__ + "img/pl.cc02a13d.png";